import React from 'react';
import TabsRoutingWrapper from '@fingo/lib/components/layout/TabsRoutingWrapper';
import SalesSideFactoring from '../views/App/sales/SalesSideFactoring';
import SalesSideOrdering from '../views/App/sales/SalesSideOrdering';
import SalesSideAccountable from '../views/App/sales/SalesSideAccountable';
import SalesSideClients from '../views/App/sales/SalesSideClients';
import CollectionSummaryView from '../views/App/sales/CollectionSummaryView';
import CollectionDebtorsView from '../views/App/sales/CollectionDebtorsView';
import CollectionLandingView from '../views/App/sales/CollectionLandingView';
import CollectionReportView from '../views/App/sales/CollectionReportView';
import SalesCollection from '../views/App/sales/SalesCollection';
import AvailableFactoring from '../views/App/sales/factoring/AvailableFactoring';
import EvaluationInvoice from '../views/App/sales/factoring/EvaluationInvoice';
import AvailableOffers from '../views/App/sales/factoring/AvailableOffers';
import CurrentOperationsStatus from '../views/App/sales/factoring/CurrentOperationsStatus';
import HistoricOperationsStatus from '../views/App/sales/factoring/HistoricOperationsStatus';
import AvailableOrdering from '../views/App/sales/ordering/AvailableOrdering';
import OfferOrdering from '../views/App/sales/ordering/OfferOrdering';
import ActiveOperations from '../views/App/sales/ordering/ActiveOperations';
import HistoricOperations from '../views/App/sales/ordering/HistoricOperations';
import MySales from '../views/App/sales/sales/MySales';
import MyClients from '../views/App/sales/clients/MyClients';
import CollectionSummary from '../views/App/sales/home/CollectionSummary';
import Debtors from '../views/App/sales/debtors/Debtors';
import CollectionLanding from '../views/App/sales/collection-landing/CollectionLanding';
import Collection from '../views/App/sales/collection-report/Collection';
import AppDebtor from '../views/App/sales/Debtor';

const salesSubRoutes = () => [
  {
    id: 'sales-side-factoring',
    label: 'Financiamiento de facturas',
    path: 'factoring',
    component: <SalesSideFactoring />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'sales-side-ordering',
    label: 'Financiamiento de OC',
    path: 'ordering',
    component: <SalesSideOrdering />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'sales-side-accountable',
    label: 'Cuentas por cobrar',
    path: 'accountable',
    component: <SalesSideAccountable />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'sales-side-clients',
    label: 'Clientes',
    path: 'clients',
    component: <SalesSideClients />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'sales/collection',
    label: 'KobrosText',
    path: 'sales/collection',
    component: <SalesCollection />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'collection',
    label: 'collection',
    path: 'collection',
    component: [
      {
        id: 'collection-summary-view',
        label: 'Resumen',
        path: 'home',
        component: <CollectionSummaryView />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
      {
        id: 'collection-debtors-view',
        label: 'Lista de clientes',
        path: 'debtors',
        component: <CollectionDebtorsView />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
      {
        id: 'collection-landing-view',
        label: '¿Qué es koBros?',
        path: 'collection-landing',
        component: <CollectionLandingView />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
      {
        id: 'collection-report-view',
        label: 'Reportería',
        path: 'collection-report',
        component: <CollectionReportView />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
    ],
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const factoringTabs = () => [
  {
    id: 'factoring-tab-available',
    label: 'Disponibles',
    path: 'available',
    component: <AvailableFactoring />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'factoring-tab-evaluation',
    label: 'En evaluación',
    path: 'evaluation',
    component: <EvaluationInvoice />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'factoring-tab-offers',
    label: 'Aprobadas',
    path: 'offers',
    component: <AvailableOffers />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'factoring-tab-current-operations',
    label: 'Vigentes',
    path: 'current',
    component: <CurrentOperationsStatus />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'factoring-tab-historic-operations',
    label: 'Históricas',
    path: 'historic',
    component: <HistoricOperationsStatus />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

export const orderingTabs = () => [
  {
    id: 'ordering-tab-available',
    label: 'Financiamiento de OC',
    path: 'available',
    component: <AvailableOrdering />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'ordering-tab-offers',
    label: 'OC con oferta',
    path: 'offer',
    component: <OfferOrdering />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'ordering-tab-active',
    label: 'Operaciones activas',
    path: 'active',
    component: <ActiveOperations />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'ordering-tab-finished',
    label: 'Operaciones terminadas',
    path: 'finished',
    component: <HistoricOperations />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const salesTabs = () => [
  {
    id: 'my-sales',
    label: 'Cuentas por cobrar',
    path: 'my-sales',
    component: <MySales />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const clientsTabs = () => [
  {
    id: 'contacts',
    label: 'Clientes',
    path: 'contacts',
    component: <MyClients />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const newSummaryTabs = () => [
  {
    id: 'summary',
    label: 'Resumen de cobranza',
    path: 'summary',
    component: <CollectionSummary />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const collectionTabs = () => [
  {
    id: 'debtors',
    label: 'Clientes',
    path: 'debtors',
    component: <Debtors />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const collectionLandingTabs = () => [
  {
    id: 'kobros-landing-info',
    label: '¿Qué es koBros?',
    path: 'landing-info',
    component: <CollectionLanding />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const summaryTabs = () => [
  {
    id: 'summary',
    label: 'Resumen de cobranza',
    path: 'summary',
    component: <Collection />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

const salesRoutes = () => [
  {
    id: 'sales',
    label: 'Mis ventas',
    path: '/app/sales',
    component: <TabsRoutingWrapper options={salesSubRoutes()} />,
    disabled: false,
    show: true,
    showInNavbar: false,
    subRoutes: salesSubRoutes(),
  },
  {
    id: 'debtor/:debtorId',
    label: 'Perfil de Cliente',
    path: '/app/debtor/:debtorId',
    component: <AppDebtor />,
    disabled: false,
    show: false,
    showInNavbar: false,
    subRoutes: [],
  },
];

export default salesRoutes;
